/**
 * The active professional tab is the one whose path is the longest prefix of the
 * current path. Legacy in-page filter/sort state is written as extra path
 * segments *under* the tab (e.g. `/case-studies/category_kitchen/sort_newest`),
 * so an exact `path === tabLink` match would drop the active tab — and the
 * Projects dark bar — the moment a filter is applied. Longest-prefix keeps the
 * deepest tab active while still letting the bare Overview path win on its own.
 *
 * Shared by {@link ProfessionalSubNav} (mobile) and
 * {@link ProfessionalDesktopSubNav} so the two navs can't drift.
 */
export const getActiveTabLink = (
    tabLinks: string[],
    currentPath: string,
): string =>
    tabLinks
        .filter(
            (link) =>
                currentPath === link || currentPath.startsWith(`${link}/`),
        )
        .reduce(
            (longest, link) => (link.length > longest.length ? link : longest),
            '',
        );

/** Whether the current path sits on `tabLink` (exact or under it, filters and
 *  all) — a segment-aware replacement for `endsWith`. */
export const isOnTabPath = (tabLink: string, currentPath: string): boolean =>
    currentPath === tabLink || currentPath.startsWith(`${tabLink}/`);
